import colorMod from 'color';
import { get } from 'lodash';

const styles = ({ color }) => ({
  leftBorder: {
    width: 36,
    borderTop: `1px solid ${get(color, 'borderColor')}`,
    borderBottom: `1px solid ${get(color, 'borderColor')}`,
    backgroundColor: `${colorMod(get(color, 'borderColor')).alpha(0.1).string()} !important`,
  },
  rightBorder: {
    width: 36,
    borderLeft: `1px solid ${get(color, 'borderColor')}`,
    borderTop: `1px solid ${get(color, 'borderColor')}`,
    borderBottom: `1px solid ${get(color, 'borderColor')}`,
    backgroundColor: `${colorMod(get(color, 'borderColor')).alpha(0.1).string()} !important`,
  },
});

export default styles;
